import { findConfig } from './formly-configs';

import { DynamicFormLayoutPlace, ISPFieldConfig } from '../model';

/**
 * Get field configs distributed in certain places on the layout
 *
 * @param configs - dynamic form field configs
 */
export function getConfigsDistributedInPlacesInLayout(
  configs: ISPFieldConfig[],
): Record<DynamicFormLayoutPlace, ISPFieldConfig[]> {
  return configs.reduce<Record<DynamicFormLayoutPlace, ISPFieldConfig[]>>(
    (places, config) => {
      let place: DynamicFormLayoutPlace | undefined = config.props?.layoutPlace;
      if (!place && config.fieldGroup) {
        const fieldWithPlace = findConfig(config.fieldGroup, c =>
          Boolean(c.props.layoutPlace),
        );
        place = fieldWithPlace?.props?.layoutPlace;
      }

      switch (place) {
        case 'aside':
          places.aside.push(config);
          break;
        case 'header':
          places.header.push(config);
          break;
        case 'footer':
          places.footer.push(config);
          break;
        case 'summary':
          places.summary.push(config);
          break;
        case 'absolute':
          places.absolute.push(config);
          break;
        case 'pageFooter':
          places.pageFooter.push(config);
          break;
        case 'underForm':
          places.underForm.push(config);
          break;
        case 'content':
        default:
          places.content.push(config);
          break;
      }
      return places;
    },
    {
      header: [],
      content: [],
      footer: [],
      summary: [],
      aside: [],
      absolute: [],
      pageFooter: [],
      underForm: [],
    },
  );
}
